import Cookies from 'js-cookie';

const getGraphqlEndpoint = () => {
  const previewLink = Cookies.get('preview_gateway');
  return process.env.NODE_ENV === 'development'
    ? 'https://staging.bitcasino.io/graphql'
    : previewLink ?? `${location.origin}/graphql`;
};
export default getGraphqlEndpoint;
